import Address from './address';
import { BannerResult } from './bannerResult';
import Button from './Button';
import Catalog from './catalog';
import CMS from './cmsResult';
import Comments from './Comments';
import { Country } from './country';
import Currency from './currency';
import Express from './express';
import ExpressAndOutlets from './ExpressAndOutlets';
import ExpressPoint from './ExpressPoint';
import { LoginResult } from './loginResult';
import { MemberResult } from './memberResult';
import Message from './Message';
import Order from './order';
import PanelDetail from './PanelDetail';
import Payment from './payment';
import PickupAddress from './pickupAddress';
import ProductAttr from './ProductAttr';
import { Promotion } from './promotionResult';
import { Province } from './province';
import ShopCart from './ShopCart';
import ShopCartItem from './shopCartItem';
import Tab from './Tab';
import YouWouldLike from './youWouldLike';
import PromotionDiscount from './PromotionDiscount';
import Catalogs from './Catalogs';
export default {
  Address: Address,
  BannerResult: BannerResult,
  Button: Button,
  Catalog: Catalog,
  CMS: CMS,
  Comments: Comments,
  Country: Country,
  Currency: Currency,
  Express: Express,
  ExpressAndOutlets: ExpressAndOutlets,
  ExpressPoint: ExpressPoint,
  LoginResult: LoginResult,
  MemberResult: MemberResult,
  Message: Message,
  Order: Order,
  PanelDetail: PanelDetail,
  Payment: Payment,
  PickupAddress: PickupAddress,
  ProductAttr: ProductAttr,
  Promotion: Promotion,
  Province: Province,
  ShopCart: ShopCart,
  ShopCartItem: ShopCartItem,
  Tab: Tab,
  YouWouldLike: YouWouldLike,
  PromotionDiscount: PromotionDiscount,
  Catalogs: Catalogs
};
